/* =================== MINHA CONTA =================== */
jQuery(document).ready(function ($) {
  // Exibe a confirmação ao clicar no botão de remover
  $(".btn-confirm").on("click", function (e) {
    e.preventDefault();
    var idRemove = $(this).data("id");
    $("#id_remove").val(idRemove);
    openModal("modal-confirm");
  });

  // Exibe a confirmação ao clicar no botão de cancelar plano
  $(".btn-cancela").on("click", function (e) {
    e.preventDefault();
    var idCancela = $(this).data("id");
    $("#id_cancela").val(idCancela);
    openModal("modal-cancelar");
  });

  // Exibe/Oculta os campos da forma de pagamento escolhida
  $('input[name="forma-pagamento"]').on("change", function () {
    $(".forma-pag-content").slideUp();
    $(".forma-pag-content .campo").prop("disabled", true);
    $(".forma-pag-content .campo").prop("required", false);

    $('.forma-pag-content[data-forma="' + $(this).val() + '"]').slideDown();
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "disabled",
      false
    );
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "required",
      true
    );
  });
});
